import { Component } from '@angular/core';

@Component({
  selector: 'app-my-supliers-page',
  template: `
    <!--<app-page-title [title]="pageTitle"></app-page-title>-->
    <router-outlet></router-outlet>
  `,
})
export class MySupliersPageComponent {
  pageTitle = 'Mis proveedores';
  constructor() {}
}
